import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Form, Modal, Row } from "antd";
import AdnCard from "../common/adnCard/AdnCard";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import AdnAddButton from "../common/adnAddButton/AdnAddButton";
import AdnInput from "../common/adnInput/AdnInput";

const CertificationTypesListForm = ({
  title,
  loading,
  columns,
  certificationTypes,
  totalRecords,
  handleChangePage,
  handleAdd,
  modalState,
  modalVisible,
  setModalVisible,
  form,
  handleFinish,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard loading={loading}>
        <Row>
          <Col span={24}>
            <AdnAddButton
              style={{ float: "right" }}
              name={t("certificationTypes.form.buttons.certification")}
              handleClick={handleAdd}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <AdnTable
              columns={columns}
              data={certificationTypes}
              totalRecords={totalRecords}
              handleChangePage={handleChangePage}
              pagination={false}
            />
          </Col>
        </Row>
      </AdnCard>
      <Modal
        title={modalState}
        open={modalVisible}
        onOk={form.submit}
        okText={t("certificationTypes.form.buttons.save")}
        onCancel={() => {
          setModalVisible(false);
        }}
        cancelText={t("certificationTypes.form.buttons.back")}
      >
        <Form
          form={form}
          name="form_in_modal"
          layout="vertical"
          onFinish={handleFinish}
        >
          <AdnInput
            name={"certificationDescription"}
            label={t("certificationTypes.form.labels.certificationDescription")}
            placeholder={t(
              "certificationTypes.form.placeholders.insertCertificationDescription"
            )}
            maxLength={200}
            rules={[
              {
                required: true,
                message: t(
                  "certificationTypes.form.validation.certificationDescriptionRequired"
                ),
              },
            ]}
          />
          <AdnInput
            name={"certificationProvider"}
            label={t("certificationTypes.form.labels.certificationProvider")}
            placeholder={t(
              "certificationTypes.form.placeholders.insertCertificationProvider"
            )}
            maxLength={100}
            rules={[
              {
                required: true,
                message: t(
                  "certificationTypes.form.validation.certificationProviderRequired"
                ),
              },
            ]}
          />
        </Form>
      </Modal>
    </>
  );
};

export default CertificationTypesListForm;
